import "./Home.module.css";
import GlobalNavigation from "@/reusable_sections/Header";
import PremiumProductCategories from "./sections/PremiumProductCategories";
import DailyEssentials from "./sections/DailyEssentials";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <GlobalNavigation />
      <PremiumProductCategories />
      <DailyEssentials />
      <Footer />
    </div>;
}